export enum UsersImportStep {
  DATA = 0,
  FIELDS = 10,
  SETTINGS = 20,
  RESULTS = 40
}
